// A module's localized name and one-line launcher description, resolved from the
// shared `lumiModules.<key>` group of app-kit's catalogue (merged under every app's
// own messages). The @lumi/ui registry carries no displayed string, so this is the
// one place app glue turns a module key into words — and the shared tier stays free
// of translations it would otherwise have to duplicate per app.
//
// `admin` has no entry: tenant administration is a section of the workspace, not a
// module (#432), so it is never named or listed. Asking for it echoes the key.
import type { LumiModuleKey } from '@lumi/ui';
import { t } from '../i18n';

export function moduleName(key: LumiModuleKey): string {
  return t(`lumiModules.${key}.name`);
}

export function moduleDescription(key: LumiModuleKey): string {
  return t(`lumiModules.${key}.description`);
}
